import { render, staticRenderFns } from "./SystemEmails.vue?vue&type=template&id=871b3744"
import script from "./SystemEmails.vue?vue&type=script&lang=js"
export * from "./SystemEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports